import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { ElAsyncAutocompleteModule } from '@el-async-autocomplete';
import { ElDataListTableModule } from '@el-data-list-table';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MtxDatetimepickerModule } from '@ng-matero/extensions/datetimepicker';
import { TranslateModule } from '@ngx-translate/core';
import { CalendarModule } from 'angular-calendar';

import { MaterialModule } from '../../material.module';
import { SharedModule } from '../shared/shared.module';

import { AddEditInventoryComponent } from './components/add-edit-inventory/add-edit-inventory.component';
import { InventoryComponent } from './components/inventory/inventory.component';
import { AssetAllocateComponent } from './popups/asset-allocate/asset-allocate.component';
import { AssetAllocateErrorPopupComponent } from './popups/asset-allocate-error-popup/asset-allocate-error-popup.component';
import { AssetAllocateHistoryPopupComponent } from './popups/asset-allocate-history/asset-allocate-history';
import { ImagePopupDialogComponent } from './popups/image-popup/image-popup.component';
import { ReturnAssetComponent } from './popups/return-popup/return-popup.component';
import { InventoryRoutingModule } from './inventory-routing.module';

@NgModule({
  declarations: [
    InventoryComponent,
    AddEditInventoryComponent,
    AssetAllocateErrorPopupComponent,
    AssetAllocateHistoryPopupComponent,
    AssetAllocateComponent,
    ReturnAssetComponent,
    ImagePopupDialogComponent,
  ],
  imports: [
    NgbModule,
    SharedModule,
    ReactiveFormsModule,
    TranslateModule,
    CommonModule,
    ElDataListTableModule,
    MaterialModule,
    InventoryRoutingModule,
    MatChipsModule,
    CalendarModule,
    MtxDatetimepickerModule,
    ElAsyncAutocompleteModule,
  ],
})
export class InventoryModule {}
